import { useSelector } from 'react-redux'

import { selectAppName } from 'root-redux/selects/common'

import { AppName } from 'root-constants'

import { RETENTION_FLOW_V2_CONFIGS, TRetentionFlowV2Config } from '../constants'

export const useRetentionFlowV2Config = (): TRetentionFlowV2Config & {
  appName: AppName
} => {
  const appName = useSelector(selectAppName) as AppName

  return {
    appName,
    ...(RETENTION_FLOW_V2_CONFIGS[appName] as TRetentionFlowV2Config),
  }
}
